import Swiper from 'swiper';
import { Navigation, Thumbs, Pagination, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// import SimpleLightbox from 'simplelightbox';
// import 'simplelightbox/dist/simple-lightbox.min.css';

import { init } from 'litelight-js';
import 'litelight-js/css';

export function loadProductSwiper() {


    init({
        imageSelector: 'img[data-gallery]',     // CSS selector for images
        imageUrlAttribute: 'data-gallery',      // Attribute with full-size URL
        swipeThreshold: 75,                     // Swipe distance to navigate
        fadeAnimationDuration: 200              // Animation duration (ms)
    });;

    const upsellSwiper = new Swiper(".upsell-swiper", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-upsell-next",
        prevEl: ".swiper-upsell-prev",
      },
      modules: [Navigation],
    });

    const productThumbSwiper = new Swiper(".product-thumb-swiper", {
      modules: [FreeMode, Thumbs],
      watchSlidesProgress: true,
      freeMode: true,
      spaceBetween: 16,
      slidesPerView: 2.8,
      breakpoints: {
        0:   { 
            slidesPerView: 2.6,
        },
        540: { 
            slidesPerView: 2.6,
        },
        768: {
             slidesPerView: 2.6,
            },
        1024:{ 
            slidesPerView: 3.5
        },
        1280:{
             slidesPerView: 3.5
        }
      },         
      a11y: {
        enabled: true
      }
    });

    const productSwiper = new Swiper(".product-swiper", {
      spaceBetween: 10,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      modules: [Navigation, Thumbs, Pagination],
      thumbs: {
        swiper: productThumbSwiper,
      },
      
    });
}
